var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarCog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-calendar-cog",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21h-6a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 3v4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 3v4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11h16"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.001 15.5v1.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.001 21v1.5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.032 17.25l-1.299 .75"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.27 20l-1.3 .75"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.97 17.25l1.3 .75"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.733 20l1.3 .75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarCog);
export default __webpack_public_path__ + "static/media/calendar-cog.dce4d45b.svg";
export { ForwardRef as ReactComponent };